/* Layout */
import Layout from '../../views/layout/Layout.vue'

const EditorialList = () => import(/* webpackChunkName: "editorial-list" */ '@/views/editorial/list')
const EditorialDetail = () => import(/* webpackChunkName: "editorial-detail" */ '@/views/editorial/detail')
const EditorialDetailReadonly = () => import(/* webpackChunkName: "editorial-detail-readonly" */ '@/views/editorial/readonly')

export default [
  {
    path: '/editorial',
    component: Layout,
    redirect: '/editorial/list',
    name: 'Editorial',
    alwaysShow: true,
    meta: {
      title: 'editorial',
      icon: 'images',
    },
    children: [
      {
        path: 'create',
        component: EditorialDetail,
        name: 'EditorialCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'editorial',
        },
      },
      {
        path: 'edit/:id',
        component: EditorialDetail,
        props: true,
        name: 'editorialEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'editorial',
        },
      },
      {
        path: 'view/:id',
        component: EditorialDetailReadonly,
        props: true,
        name: 'editorialView',
        hidden: true,
        meta: {
          title: 'view',
          accessibleName: 'editorial',
        },
      },
      {
        path: 'list',
        component: EditorialList,
        name: 'EditorialList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'editorial',
        },
      },
    ],
  },
]
